import type { Timezone } from '@bb/domain/dist/types';
import Axios from 'axios';

type GetDefaultListingTimezoneType = {
  orgId?: string;
  location?: number | string;
  address?: number | string;
  listingId?: string;
};

const getDefaultListingTimezone = async ({
  orgId,
  location,
  address,
  listingId,
}: GetDefaultListingTimezoneType) => {
  const { data } = await Axios.get<Timezone>(
    '/listing/get_default_listing_timezone',
    {
      params: {
        orgId,
        location,
        address,
        listingId,
      },
    },
  );
  return data;
};

export default getDefaultListingTimezone;
